import React from "react";
import { useNavigate } from "react-router-dom";

export default function MembershipRedirectOverlay({ serviceName = "this service" }) {
  const navigate = useNavigate();

  return (
    <div style={wrapperStyle}>
      {/* blurred content placeholder */}
      <div style={blurredBgStyle} aria-hidden="true" />

      <div style={cardStyle}>
        <div style={iconStyle}>🔒</div>
        <h2 style={headingStyle}>Upgrade Required</h2>
        <p style={bodyStyle}>
          Access to <strong>{serviceName}</strong> requires a membership plan.
          Upgrade to unlock this service and more.
        </p>
        <div style={{ display: "flex", gap: 12, justifyContent: "center", marginTop: 20 }}>
          <button onClick={() => navigate("/membership")} style={primaryBtn}>
            View Membership Plans
          </button>
          <button onClick={() => navigate(-1)} style={secondaryBtn}>
            Go Back
          </button>
        </div>
      </div>
    </div>
  );
}

const wrapperStyle = {
  position: "relative", minHeight: "60vh", display: "flex",
  alignItems: "center", justifyContent: "center",
};
const blurredBgStyle = {
  position: "absolute", inset: 0,
  background: "linear-gradient(135deg, #e8f5e9 0%, #f3e5f5 100%)",
  filter: "blur(8px)", opacity: 0.6,
};
const cardStyle = {
  position: "relative", zIndex: 1, textAlign: "center",
  background: "#fff", borderRadius: 16, padding: "40px 48px",
  boxShadow: "0 8px 32px rgba(0,0,0,0.15)", maxWidth: 440,
};
const iconStyle = { fontSize: 48, marginBottom: 12 };
const headingStyle = { fontSize: 22, fontWeight: 700, margin: "0 0 12px", color: "#1a1a2e" };
const bodyStyle = { color: "#555", fontSize: 15, lineHeight: 1.6, margin: 0 };
const primaryBtn = {
  padding: "10px 22px", borderRadius: 8, border: "none", cursor: "pointer",
  background: "#1a73e8", color: "#fff", fontWeight: 600, fontSize: 14,
};
const secondaryBtn = {
  padding: "10px 22px", borderRadius: 8, border: "1px solid #ccc",
  cursor: "pointer", background: "#fff", color: "#333", fontSize: 14,
};
